// import style from "./ServiceIcon.module.css";
const ServiceIcon = ({ icon, title, alt }) => {
  return (
    // <div
    //   style={{
    //     flexDirection: "column",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     gap: 18,
    //     // display: "inline-flex",
    //     display: "flex",
    //     padding: 10,
    //   }}
    // >
    //   <div
    //     style={{
    //       width: 138,
    //       height: 138,
    //       // position: "relative",
    //       // overflow: "hidden",
    //     }}
    //   >
    //     <img src={icon} alt={alt} className="icon" />
    //   </div>
    //   <div
    //     style={{
    //       textAlign: "center",
    //       flexDirection: "column",

    //       fontSize: 32,

    //       fontWeight: "600",
    //     }}
    //   >
    //     {title}
    //   </div>
    // </div>

    <div
      style={{
        width: 250,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 65,
        display: "inline-flex",
      }}
    >
      <div
        style={{
          alignSelf: "stretch",
          height: 236,
          padding: 10,
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 18,
          display: "flex",
        }}
      >
        <div
          style={{
            // width: 138,
            // height: 138,
            display: "flex",
            justifyContent: "center",
            position: "relative",
            overflow: "hidden",
            // backgroundColor: "yellow",
          }}
        >
          <img src={icon} alt={alt} style={{ width: 138 }} loading="lazy" />
        </div>
        <div
          style={{
            width: 240,
            height: 45,
            textAlign: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            color: "white",
            fontSize: 32,
            fontFamily: "Nunito Sans",
            fontWeight: "600",
            lineHeight: 120,
            wordWrap: "break-word",
            // backgroundColor: "red",
          }}
        >
          {title}
        </div>
      </div>
    </div>
  );
};

export default ServiceIcon;
